var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.02382 5.9787C5.94881 5.15536 6.20559 4.61615 5.37873 2.91359C4.60527 1.25887 4.09873 -0.156655 2.5179 1.26357C1.354 2.28811 0.962645 2.37015 0.860303 3.62472C0.610049 7.69574 6.15148 15.5462 9.95297 16.5006C11.1667 16.7708 11.3366 16.3941 12.6112 15.5169C14.3642 14.3951 13.2016 13.4976 11.9578 12.1907C10.6151 10.8914 10.0261 10.9887 8.76164 12.6443C7.43536 12.8502 3.47276 7.21584 4.02382 5.9787Z"}));
}

IconPhone.defaultProps = {"viewBox":"0 0 14 18","fill":"none"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
